import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import {
  DataService as CoreDataService,
  Query,
  QueryColumn,
  QueryColumnSortOrder,
  QueryObjectsModel,
} from '@barthauer/abc/core/data';
import { ResourceManager } from '@barthauer/abc/core/resources';
import { _AbcFormComponent, _AbcScrollViewComponent, _AbcSelectBoxComponent } from '@barthauer/abc/ui-components';
import { Address } from '@barthauer/custom/arena';
import { Project } from '@barthauer/custom/xmt-models';
import { DxScrollViewComponent } from 'devextreme-angular';
import { loadMessages, locale } from 'devextreme/localization';
import { Observable, of, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { AppService } from '../../../services/app.service';
import { DataService } from '../../../services/data.service';
import { LanguageService } from '../../../services/language.service';
import { CompaniesService, IProjectDependency, ObjectKeys } from '../companies.service';
@Component({
  selector: 'companies-card-list',
  templateUrl: './companies-card-list.component.html',
  styleUrls: ['./companies-card-list.component.scss'],
})
export class CompaniesCardListComponent implements OnInit {
  @ViewChild(DxScrollViewComponent, { static: true }) scrollView: _AbcScrollViewComponent;
  @ViewChild('filterField') filterField: _AbcSelectBoxComponent;
  @ViewChild('form') form: _AbcFormComponent;
  @Input() displayGrid: boolean = true;
  @Input() navigateUrl: string;
  @Input() companyIdDependency: IProjectDependency;
  @Input() companyNameDependency: IProjectDependency;
  @Input() configDependencies: IProjectDependency[];
  @Input() filterOptions: [] = [];
  @Output() filterData = new EventEmitter<QueryColumn[]>();
  @Output() clickProject = new EventEmitter<Project[]>();
  @Output() clickCompany = new EventEmitter<Address>();
  @Output() selectLastProjectUpdated = new EventEmitter<Project>();
  public searchTerm = new Subject<string>();
  public blurPage = true;
  public companies: Address[];
  public company: Address;
  public companySelected: Address = new Address(null);
  // public isCompanySelected: boolean = false;
  public originalCompanyData: Address;
  public cachedStatus = [];
  public cachedCompaniesTitles: string[] = [];
  public clonedCompanies: Address[];
  public columns: QueryColumn[] = [];
  public emptyCompany = false;
  public filterActive = false;
  public items = [];
  public isFavorite = false;
  public res!: any;
  public resourceManager!: ResourceManager;
  // public projectList: Project[] = [];
  private projectColumns = [
    this.coreDataService.createQueryColumn('Id', 'Id', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn('Designation', 'Label', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn('ref:ParentId', 'ParentAddress', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn('SysDateInsert', 'Date', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn('Description', 'Description', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn('StartDate', 'StartDate', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn('EndDate', 'EndDate', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn('State', 'State', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn('Count(subProjects)', 'subProjectsCount', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn('Count(subProjects.Measures)', 'measuresCount', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn(
      'Count(subProjects.Measures.MeasureTasks)',
      'tasksCount',
      QueryColumnSortOrder.None
    ),
    this.coreDataService.createQueryColumn('SysDateUpdate', 'SysDateUpdate', QueryColumnSortOrder.Descending),
    this.coreDataService.createQueryColumn(
      "FormatTime(SysTimeUpdate, 'hh:mm:ss')",
      'SysTimeUpdate',
      QueryColumnSortOrder.Descending
    ),
  ];
  private comapnyNumber = 100;
  private subscriptions: Subscription[] = [];
  public selectedCompany: string = '';
  currentLanguage: string | null;
  constructor(
    private coreDataService: CoreDataService,
    private companiesService: CompaniesService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private languageService: LanguageService,
    public appService: AppService,
    public dataService: DataService
  ) {
    this.res = ResourceManager.getResources('ubt-geods');
  }
  public ngOnInit(): void {
    this.subscriptions.push(
      this.companiesService.selectedCompany$.subscribe((selectedCompany) => {
        this.selectedCompany = selectedCompany;
      })
    );

    this.languageService.localStorageChanges$.subscribe((value) => {
      this.currentLanguage = value;
      this.updateTranslations();
    });

    this.filterCompanyWithProject();
    this.company = new Address(null);
    this.prepareCompanyQueryColumns();
    this.blurPage = false;
    this.search(this.searchTerm).subscribe((results) => {
      this.companies = [];
      this.emptyCompany = false;
      if (results !== null) {
        this.filterActive = true;
        if (results.length === 0) {
          this.emptyCompany = true;
        } else {
          this.companies = results;
        }
      } else {
        this.companies = this.clonedCompanies.slice(0, this.comapnyNumber + 100);
      }
      this.cdr.markForCheck();
    });

    this.subscriptions.push(
      this.companiesService.updateGridData$.subscribe((company: Address) => {
        this.companies.push(company);
      })
    );

    this.subscriptions.push(
      this.companiesService.selectedCompanyData$.subscribe((selectedCompany) => {
        if (selectedCompany === true) {
          this.getProjectsData();
          this.getCompanySelected();
        }
      })
    );
  }
  public hoverCompanyAction(event) {
    this.appService.isCompanySelected = true;
    this.selectedCompany = event;
  }
  public resetSearch(event): void {
    if (event.value === '') {
      this.searchTerm.next('');
    }
  }

  public switchToCompanyProject(): void {
    this.appService.isCompanySelected = true;
  }

  public filterCompanyWithProject() {
    this.subscriptions.push(
      this.companiesService.filterCompanyData$.subscribe((filteredCompanies: Address[] | number) => {
        if (typeof filteredCompanies === 'number') {
          this.filterField.value = this.filterOptions[filteredCompanies]['id'];
          this.filterData.emit(this.columns);
        } else {
          this.companies = filteredCompanies.slice(0, this.comapnyNumber);
          this.clonedCompanies = [...filteredCompanies];
          this.items = this.clonedCompanies.map((filteredCompanies) => {
            return { ...filteredCompanies, searchProperty: filteredCompanies.Name.toUpperCase() };
          });
          this.cdr.markForCheck();
        }
      })
    );
  }

  public prepareCompanyData() {
    this.subscriptions.push(
      this.readCompanyWithImages().subscribe(
        (companiesData) => {
          this.companies = companiesData.slice(0, this.comapnyNumber);
          this.clonedCompanies = [...companiesData];
          this.items = this.clonedCompanies.map((company) => {
            return { ...company, searchProperty: company.Name.toUpperCase() };
          });
          this.cdr.markForCheck();
        },
        (error) => {
          console.error(error);
        }
      )
    );
  }

  public navigateToDashboard(project): void {
    this.clickProject.emit(project);
    this.router.navigate(['dashboard']);
  }

  public clickCompanyAction(company): void {
    this.switchToCompanyProject();
    this.clickCompany.emit(company);
  }

  public selectLastProjectUpdatedAction(project): void {
    this.selectLastProjectUpdated.emit(project);
  }

  private getCompanySelected() {
    const companyId = localStorage.getItem('currentCompany');
    const opath = 'Id=' + "'" + companyId + "'";
    this.companiesService.readObjects<Address[]>(ObjectKeys.ADDRESS, this.columns, opath).subscribe(
      (company) => {
        if (Array.isArray(company) && company.length > 0) {
          this.companySelected = company[0];
        } else {
          this.companySelected = new Address(null);
        }
      },
      (error) => {
        console.error(error);
        this.cdr.markForCheck();
      },
      () => {
        this.cdr.markForCheck();
      }
    );
  }

  public redirectToCompanies() {
    this.appService.isCompanySelected = false;
  }

  private getProjectsData() {
    const companyId = localStorage.getItem('currentCompany');
    const opath = 'ParentId=' + "'" + companyId + "'";
    this.companiesService.readObjects<Project[]>(ObjectKeys.PROJECT, this.projectColumns, opath).subscribe(
      (projects) => {
        if (Array.isArray(projects) && projects.length > 0) {
          this.appService.projectList = projects;
        } else {
          this.appService.projectList = [];
        }
      },
      (error) => {
        console.error(error);
        this.cdr.markForCheck();
      },
      () => {
        this.cdr.markForCheck();
      }
    );
  }

  public search(terms: Observable<string>) {
    return terms.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap((term) => this.searchEntries(term))
    );
  }

  public searchEntries(term: string) {
    if (!term) return of(null);
    term = term.toUpperCase();
    return of(this.items.filter((a) => a.searchProperty.indexOf(term) >= 0));
  }

  public selectFilterOption(event) {
    const filterAction = event.itemData.id;
    if (filterAction === 0) {
      this.prepareCompanyData();
    } else if (filterAction === 1) {
      this.filterCompanyWithProject();
      this.filterData.emit(this.columns);
    }
  }

  public prepareCompanyQueryColumns() {
    this.columns.push(
      this.coreDataService.createQueryColumn('Id', 'Id'),
      this.coreDataService.createQueryColumn('Name', 'Name'),
      this.coreDataService.createQueryColumn('MatchCode', 'MatchCode'),
      this.coreDataService.createQueryColumn('Status', 'Status'),
      this.coreDataService.createQueryColumn('CompanyTitle', 'CompanyTitle'),
      this.coreDataService.createQueryColumn('Phone', 'Phone'),
      this.coreDataService.createQueryColumn('Fax', 'Fax'),
      this.coreDataService.createQueryColumn('EMail', 'EMail'),
      this.coreDataService.createQueryColumn('Street', 'Street'),
      this.coreDataService.createQueryColumn('CustomerNumber', 'CustomerNumber'),
      this.coreDataService.createQueryColumn('HouseNumber', 'HouseNumber'),
      this.coreDataService.createQueryColumn('ZIP', 'ZIP'),
      this.coreDataService.createQueryColumn('Country', 'Country'),
      this.coreDataService.createQueryColumn('City', 'City'),
      this.coreDataService.createQueryColumn(
        "Exists(Type(BoxDetail)[Box.ParentId = $CurrentUserId AND Box.Designation = 'Favoriten' AND ParentId = ^.Id])",
        'IsFavorite'
      ),
      this.coreDataService.createQueryColumn(
        "Type(BoxDetail)[Box.ParentId = $CurrentUserId AND Box.Designation = 'Favoriten' AND ParentId = ^.Id].Id",
        'BoxDetailId'
      ),
      this.coreDataService.createQueryColumn('SysDateUpdate', 'SysDateUpdate', QueryColumnSortOrder.Descending),
      this.coreDataService.createQueryColumn(
        "FormatTime(SysTimeUpdate, 'hh:mm:ss')",
        'SysTimeUpdate',
        QueryColumnSortOrder.Descending
      )
    );
  }

  private readCompanyWithImages(): Observable<any> {
    const adressQuery: Query = new Query();
    const adressColumns: Array<QueryColumn> = this.columns;
    adressQuery.Columns = adressColumns;
    adressQuery.ObjectType = ObjectKeys.ADDRESS;

    const imageQuery: Query = new Query();
    imageQuery.Name = 'Image';
    imageQuery.OPath = 'Documents';
    const imageColumns: Array<QueryColumn> = [
      this.coreDataService.createQueryColumn('Id', 'Id', QueryColumnSortOrder.None),
      this.coreDataService.createQueryColumn('Designation', 'Designation', QueryColumnSortOrder.None),
      this.coreDataService.createQueryColumn('Object', 'Object', QueryColumnSortOrder.None),
      {
        Name: 'Object',
        OPath: 'Object',
        Format: 'Base64Image[80x80]',
      },
    ];
    imageQuery.Columns = imageColumns;
    imageQuery.OPath = "Documents[Kind='IMAGE']";
    adressQuery.ObjectQueries = [imageQuery];
    const queryDocument: QueryObjectsModel = new QueryObjectsModel();
    queryDocument.ObjectQueries = [adressQuery];
    return this.coreDataService.executeReadObjectsQuery(queryDocument);
  }
  updateTranslations(): void {
    if (this.currentLanguage === 'de' || this.currentLanguage === null) {
      loadMessages('de');
      locale('de');
    } else {
      loadMessages('en');
      locale('en');
      ResourceManager.changeLanguage(this.currentLanguage);
    }
    this.cdr.detectChanges();
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
